import {stakeColumns, useGetStakes} from '@entities/stake';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';
import {Header} from '@widgets/common';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'stakesTableV1';

export const StakesPage = () => {
  const {urlState, setUrl} = useUrlState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const {
    data,
    isPending: isLoading,
    error,
  } = useGetStakes({
    page: urlState.pageIndex + 1,
    pageSize: urlState.pageSize,
  });

  return (
    <MrTable
      columns={stakeColumns}
      data={data?.items ?? []}
      error={error}
      renderTopToolbarCustomActions={() => (
        <Header title="Stakes" isBackButtonShown={false} />
      )}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      state={{isLoading, pagination: urlState}}
      enableColumnPinning
      initialState={{columnPinning: {left: ['id']}}}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
